import React from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

const SearchInput = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? t("admin.superUser.searchPlaceholder")}
        className="w-64 rounded-lg border border-[#E5E7EB] py-2 pl-9 pr-4 text-sm text-[#111827] placeholder-[#9CA3AF] outline-none transition-all duration-150 focus:border-[#E07A3A] focus:ring-2 focus:ring-[#E07A3A]/10"
      />
    </div>
  );
};

export default SearchInput;
